var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_48_379",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_48_379",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAAB8klEQVRYhe1WQW4aQRAsJzn46CcQPhD/wFiqB8APzAscXoD9AuIXYN9yC0cfWmJzyzH5AOEJ+wSrUa3VXmaWXYwlK6EkBDOz213dXd0MjvjvcdKUAJI9AFMAQwBnHZNVAlgAuDWzde6hLAGSN3J+CEzM7FtrAiS/ApiFrQLAz45ELgAMwjpJYouA0v5XS0/j2MwW+2SBpJduHsr3uV6OD4n3Ytr3cu7lI7kE4M7GGdsbfEq8P9R30eSc5DmAnqJbm1kR9itHMzO7JFmoHMMaoSSBKl3JmiutMzmP+x7tnZRfoQy2BqlOShHIgqTX8ypz3hOxL15rrX/vstmagCKvnJeKttDao7tWhP7Mn1zb7U0gtKU7vzSzGF1B0lO/FAnXQCsCqS7YQhCc467mfAPtTbQ8IznIW+xIoCaeouG5eHZ+SAJvhrYEyvC7KbXxbGcHOFoRUH2rEXotTbyA9p6FWg2mXejSBS6wH9LDkmSuDR23bY221oDG8r2WVast9ZkG5/dtZ0AnAiLhc3wUyhGx1l/uOG9hG6kSlIrmIkPCM7GozYZdNa9slfWD1H0gzvvRvneBYG8o7UDleZGhVAmigOYy8Brn84ztDd7flayBxGuQvZR+zBldrVa/+v3+gwTpYjvtSMAF9106ejxQIEf8awDwBL5gsIOKFThyAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4255ad43becf9b112fbc8aee1ef578fe.svg";
export { ForwardRef as ReactComponent };